import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProductReveal() {
  return <section className="py-16 px-4 bg-navy-900 relative overflow-hidden" data-id="element-240">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/50 to-transparent" data-id="element-241"></div>
      <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-gold-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-242"></div>

      <div className="max-w-5xl mx-auto text-center" data-id="element-243">
        <FadeIn data-id="element-244">
          <span className="inline-block py-1 px-3 border border-gold-500/30 text-gold-400 text-sm tracking-widest uppercase mb-8 rounded-sm" data-id="element-245">
            Presentando
          </span>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-246">
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold text-cream-100 mb-6 flex items-center justify-center gap-4 flex-wrap" data-id="element-247">
            KINESIOTAPING CLÍNICO PRO
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-248">
          <h3 className="text-xl md:text-2xl text-gold-400 font-body font-light max-w-3xl mx-auto mb-10" data-id="element-249">
            Más Allá de la Cinta: La Guía Definitiva para Dominar el Vendaje
            Neuromuscular con Precisión Científica y Aplicación Real
          </h3>
        </FadeIn>

        <FadeIn delay={0.3} className="relative max-w-2xl mx-auto mb-12" data-id="element-250">
          <div className="absolute inset-0 bg-gold-500/20 blur-[60px] rounded-full transform scale-90" data-id="element-251"></div>
          <img src="https://cdn.magicpatterns.com/uploads/rTj3xqXnQ7EvGSP5EWHpuJ/producto.png" alt="Kinesiotaping Clínico Pro - Impulso Vital - Edición Digital Premium" className="relative z-10 w-full h-auto rounded-sm shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-navy-700" data-id="element-252" />
        </FadeIn>

        <div className="max-w-3xl mx-auto space-y-6 text-lg text-cream-200" data-id="element-253">
          <FadeIn delay={0.4} data-id="element-254">
            <p data-id="element-255">Este no es un folleto de producto.</p>
            <p data-id="element-256">No es un resumen de blog.</p>
            <p data-id="element-257">No es otro video de YouTube con música de fondo.</p>
          </FadeIn>

          <FadeIn delay={0.5} data-id="element-258">
            <p className="text-2xl font-heading text-gold-400 mt-8 leading-relaxed" data-id="element-259">
              <strong data-id="element-260">Es un manual de práctica clínica completo</strong>,
              diseñado con el mismo rigor con el que usted atiende a sus
              pacientes: meticuloso, fundamentado y orientado a resultados
              reales.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}